<template>
    <div>
        <div class="content-box first" v-loading="dataLoading">
            <RsStep class="full" :active="1" :steps="['身份认证', '签署合同', '签署完成']"></RsStep>
            <div class="fadada-box">
                <div class="url-box">
                    <iframe :src="fadadaUrl" scrolling="no" frameborder="0"></iframe>
                </div>
            </div>
            <div class="page-btn-box">
                <el-button v-if="!verify.isVerify" @click="$router.go(-1)" :loading="btnLoading">上一步</el-button>
                <el-button type="primary" @click="dialogVisible = true">开始签署</el-button>
            </div>
            <el-dialog :title="`验证手机号${telephone}`" append-to-body :visible.sync="dialogVisible" width="450px" center>
                <div class="contract-body">
                    <el-alert
                        v-if="smsTime !== 0"
                        :title="`您尾号为${phone}的手机将会收到认证服务商“电子牵”的认证短信验证码，请填写验证码以进行电子身份认证`"
                        :closable="false"
                        type="warning"
                        show-icon
                    ></el-alert>
                    <div class="item">
                        <div class="cont">
                            <el-input placeholder="点击获取验证码进行电子合同验证" v-model="verificationCode">
                                <el-button @click="sendSms" slot="append">
                                    {{ smsTime === 0 ? '获取验证码' : `( ${smsTime}s )` }}
                                </el-button>
                            </el-input>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="signContract">确认签署</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dataLoading: false,
            btnLoading: false,
            fadadaUrl: '',
            dialogVisible: false,
            verificationCode: '',
            smsTime: 0,
            contractCode: '',
            serialNumber: '',
            isSign: false,
            telephone: '',
        };
    },
    computed: {
        verify() {
            return this.$store.state.verify || {};
        },
        phone() {
            const {telephone} = this.$store.state.userInfo || {};
            return telephone ? telephone.slice(-4) : '';
        },
    },
    mounted() {
        const {telephone} = this.$store.state.userInfo || {};
        if (telephone) this.telephone = telephone;
        this.$dzqToFdd(3);
        this.getFadadaUrl();
    },
    methods: {
        async getFadadaUrl() {
            this.dataLoading = true;
            const response = await this.$request({
                url: '/letSign/viewContract',
                method: 'post',
                formData: false,
                data: {},
            });
            this.dataLoading = false;
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.fadadaUrl = result.contractFileFullPath;
            this.contractCode = result.letSignContractCode;
        },
        async sendSms() {
            if (this.smsTime > 0) return;
            const response = await this.$request({
                url: '/letSign/smsCodeSign',
                method: 'post',
                formData: false,
                data: {
                    contractCode: this.contractCode,
                },
            });
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.serialNumber = result.serialNumber;
            this.smsTime = 60;
            const smsInterval = setInterval(() => {
                this.smsTime -= 1;
                if (this.smsTime <= 0) clearInterval(smsInterval);
            }, 1000);
        },
        async signContract() {
            if (!this.verificationCode) return this.$message.error('请填写短信验证码');
            const response = await this.$request({
                url: '/letSign/personSign',
                method: 'post',
                formData: false,
                data: {
                    verificationCode: this.verificationCode,
                    serialNumber: this.serialNumber,
                    contractCode: this.contractCode,
                },
            });
            const {state, msg} = response.data;
            if (!state) return this.$message.error(msg || '抱歉，签署失败，请确认输入的短信验证码是否正确');
            this.dialogVisible = false;
            this.$contractRouter('/manage/contract/verify/fdd/step/3');
        },
    },
};
</script>

<style lang="scss" scoped>
.fadada-box {
    display: flex;
    // align-items: center;
    // align-content: center;
    // justify-content: center;
    flex-direction: column;
    overflow: hidden;
    overflow-x: auto;

    .url-box {
        flex: 1;
        min-width: 1000px;

        iframe {
            width: 100%;
            height: 900px;
        }
    }
}

.contract-body {
    .item {
        display: flex;
        margin-top: 10px;

        label {
            width: 60px;
            line-height: 40px;
        }

        .cont {
            flex: 1;
            display: flex;
        }
    }
}
</style>
